export const API_URL =
  // 'https://godashboard-libservice-dev.corp.geosteering.ru/golibrary/api/v1/';
  /* eslint no-underscore-dangle: 0 */
  window._env_.REACT_APP_BACKEND_API_URL || process.env.REACT_APP_BACKEND_API_URL;

export const AUTH_API_URL =
  window._env_.REACT_APP_AUTH_API_URL || process.env.REACT_APP_AUTH_API_URL || 'http://10.10.7.143:8181/';

export const ENDPOINTS = {};
